<template>
  <div>
    <v-tabs v-model="tabs" show-arrows>
      <v-tab v-for="aba in abas" :key="aba.aba">
        <span class="font-size-13">{{ aba.label }}</span>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <v-tab-item v-for="aba in abas" :key="aba.aba">
        <v-card flat v-for="(item, indexItem) in aba.items" :key="indexItem">
          <v-card-text>
            <p class="font-size-17 black--text mt-2 mb-3">
              <strong>{{ item.label }}</strong>
            </p>

            <div v-if="aba.aba == 'resumo' && indexItem == 0">
              <SGPRowComponent>
                <SGPColComponent cols="12">
                  <DadosColunasComponent :largura="4" :dados="item.keys" />
                </SGPColComponent>
              </SGPRowComponent>
            </div>

            <DadosColunasComponent v-else :largura="item.cols || 3" :dados="item.keys"></DadosColunasComponent>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { objectKeyFinder } from './AbasDataType'
import { getAbasDataType } from './AbasDataTypeRegistry'
import { aplicarRotulosTelmex } from '@/common/helpers/ProvedorTelmex'
import DadosColunasComponent from './DadosColunasComponent.vue'

const ABAS_OCULTAS_EQUIPE_PROVEDOR = ['dados_cadastrais', 'transmissao', 'dados_servico']

export default {
  name: 'AbaComponent',
  components: {
    DadosColunasComponent
  },

  props: {
    circuito: {
      type: Object,
      required: true,
      default: () => ({})
    },
    provedorTipo: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      tabs: 0
    }
  },

  computed: {
    ...mapGetters('login', ['usuarioLogado', 'isProvedorTelmex']),

    usuarioPertenceEquipeProvedor() {
      const equipes = Array.isArray(this.usuarioLogado?.equipes) ? this.usuarioLogado.equipes : []
      return equipes.some(equipe => equipe?.nome === 'Equipe Provedor')
    },

    abas() {
      const dataType = aplicarRotulosTelmex(getAbasDataType(this.provedorTipo), this.isProvedorTelmex);
      const abasPermitidas = this.usuarioPertenceEquipeProvedor
        ? dataType.filter(aba => !ABAS_OCULTAS_EQUIPE_PROVEDOR.includes(aba.aba))
        : dataType

      return objectKeyFinder([...abasPermitidas], {
        ...this.circuito,
        data: this.circuito
      })
    }
  }
}
</script>
